import styled from "styled-components";
import {
  Divider,
  Grid
} from "@material-ui/core";
import {
  TextInput,
  DatePicker,
  AutoCompleteInput,
  DecimalInput,
  PercentInput,
  MoneyInput
} from "components/Global/FormikMaterial";

// Styled Grid
export const SectionGrid = styled(Grid)`padding-left:15px; max-width:670px;`;
export const TopParentGrid = styled(Grid)``;
export const ParentGrid = styled(Grid)`padding-top:10px; padding-left:15px;`;
export const LastGrid = styled(Grid)`padding-left:15px;`;
export const ButtonBar = styled(Grid)`&& > *:first-child {margin-right: 12px; }`;
export const ActionButtons = styled(ButtonBar)`
&& {
  margin-top: -3px;
  border-radius: 0;
  color: #2196f3;
  background: none;
  float: right;
  margin-right: 50px;
}
&&:hover {
  background: #f6f6f6;
}`;
export const AlignedGrid = styled(Grid)`&& {font-size:17px; }`;
export const CenterAlignedGrid = styled(AlignedGrid)`&& { background-color: rgba(249, 249, 249, 1); text-align:center; }`;
export const LeftAlignedGrid = styled(AlignedGrid)`&& { text-align:left; }`;
export const RightAlignedGrid = styled(AlignedGrid)`&& { margin-top:4px; margin-top:4px; text-align:right; }`;

// Styled Formik
export const StyledAutoCompleteInput = styled(AutoCompleteInput)`& {width:100%; }`;
export const StyledTextInput = styled(TextInput)`& {width:100%; }`;
export const StyledPercentInput = styled(PercentInput)`& {width:100%; }`;
export const StyledMoneyInput = styled(MoneyInput)`& {width:100%; }`;
export const StyledDecimalInput = styled(DecimalInput)`& {width:100%; }`;
export const StyledDatePicker = styled(DatePicker)`& {width:100%; }`;

// Styled material-ui
export const FancyDivider = styled(Divider)`&&& { background-color: #d8d8d8; width:100%; margin-bottom:4px; }`;
export const FancyDividerBlack = styled(FancyDivider)`&&& { height:3px; }`;
export const FancyDividerGray = styled(FancyDivider)`&&& { height:1px; }`;

// Styled Div
export const BlueResult = styled.div`align-items:center; background:#deeffd; color:#000; display:flex; flex-flow: column nowrap; padding:32px;`;
export const CenterAlignedValue = styled.div`&& { font-size:24px !important; text-align:center; }`;
export const WhiteBackground = styled.div`text-align:center; background:#fff; width:100%; padding:12px 0; margin-bottom:8px;`;
export const BigText = styled.div`&& { font-size:36px !important; margin:8px 0; }`;
export const Label = styled.div`text-transform:uppercase; font-size:13px !important;`;
export const PrimaryDataWrapper = styled.div`display:flex; flex-flow:column nowrap; width:100%; align-items: center;`;
export const AddRow = styled.div`display: flex; flex-flow: row nowrap; justify-content: space-between; align-items: center;`;
export const CenteredVerticalSpace = styled.div`text-align:center; margin-top:4px; margin-bottom:4px;`;
export const AdditionalInformationWrapper = styled.div`&& { margin-top: 15px; text-align:left; width: 100%; }`;
export const FlexContainer = styled.div`display:flex; flex-flow:column nowrap; justify-content:center; align-items:center;`;
export const CenterAlignedLabel = styled(Label)`&&{text-align:center; }`;
